
import {
    UPDATE_VIDEO_CURRENT_TIME,
    SET_VIDEO_VIEWWIDTH,
    SET_SUBTITLES_LEFT,
    SET_WAVEFORM_ACTIVE,
    SET_VIDEO_DURATION,
    UPDATE_WAVE_VIDEO_CURRENT_TIME
} from './types';

export const update_wave_videoCurrentTime = (result) =>async dispatch => {
    dispatch({
        type: UPDATE_WAVE_VIDEO_CURRENT_TIME,
        payload: result
    })
};


export const set_video_duration = (result) =>async dispatch => {
    dispatch({
        type: SET_VIDEO_DURATION,
        payload: result
    })
};
export const set_waveformActive = (result) =>async dispatch => {
    dispatch({
        type: SET_WAVEFORM_ACTIVE,
        payload: result
    })
};
export const update_videoCurrentTime = (videoCurrentTime) =>async dispatch => {
    dispatch({
        type: UPDATE_VIDEO_CURRENT_TIME,
        payload: videoCurrentTime
    })
};

export const set_viewWidth = (viewWidth,viewHeight) =>async dispatch => {
    dispatch({
        type: SET_VIDEO_VIEWWIDTH,
        payload: {viewWidth,viewHeight}
    })
};


export const set_subtitles_Left = (subtitles_Left ) =>async dispatch => {
    dispatch({
        type: SET_SUBTITLES_LEFT,
        payload: subtitles_Left
    })
};




// WEBPACK FOOTER //
// ./src/actions/viewOperationActions.js